import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { vendorLayoutRoute } from '../VendorLayout';

export type { VendorPOEmailFormState } from './types';
export type { VendorVenueFormState } from './types';

export const vendorSettingsRoute = createRoute({
  getParentRoute: () => vendorLayoutRoute,
  path: 'settings',
  component: lazyRouteComponent(() => import('./VendorSettingsView')),
});
